import ModelsTab from './ModelsTab';

export default ModelsTab;
